"use client";

import { useEffect, useId, useState } from "react";
import SwiperCore from "swiper";
// import "swiper/css";
// import "swiper/css/effect-fade";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "@/components/AutogeneratedCarousel/InnerCardCarousel.css";
import Icon from "@/components/ui/Icon/Icon";
import Image from "@/components/ui/Image/Image";
import { CommercetoolsProject, FavoriteItem, GroupItem, Media, PropertyEntry, SavedUnit, UnitTypeGroupItem } from "@/types";

SwiperCore.use([Pagination, Navigation]);

type InnerCardCarouselProps = {
  item?: GroupItem | UnitTypeGroupItem | SavedUnit | PropertyEntry | FavoriteItem | CommercetoolsProject;
  isHover?: boolean;
  gallery?: string[];
};
export default function InnerCardCarousel({ item, isHover, gallery }: InnerCardCarouselProps) {
  const [isMounted, setIsMounted] = useState(false);
  const carouselId = useId();
  const nextElId = useId();
  const prevElId = useId();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const images = (item ? item.images : gallery?.map((x) => ({ url: x })))?.slice(0, 5) || [];
  // 500 Error Prevention: Check if images exist before rendering anything
  if (images.length === 0) return <div className="aspect-4-3 bg-gray-10 rounded-lg" />;
  return (
    <div className="relative rounded-lg">
      <div className="hidden md:block">
        {isMounted && (
          <>
            <Swiper
              id={carouselId}
              slidesPerView={"auto"}
              pagination={{ dynamicBullets: false, clickable: true }}
              navigation={{
                prevEl: `#${CSS.escape(prevElId)}`,
                nextEl: `#${CSS.escape(nextElId)}`,
              }}
              autoHeight={true}
              className="hidden inner-carousel md:block"
              effect={"fade"}
              modules={[EffectFade, Pagination]}
            >
              {images?.map((image, index) => (
                <SwiperSlide className="w-fit rounded-lg" key={`${(item as CommercetoolsProject)?.id ?? ""}-carousel-image-${index}`}>
                  <Image className="aspect-4-3 rounded-lg w-full" alt={image.title || ""} src={image.url} width={345} height={258} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div
              className={`${isHover ? "md:flex" : "hidden md:group-hover:flex"} justify-between absolute z-10 w-full -translate-y-2/4 top-2/4 px-xs transition transform hover:duration-[6000ms]  motion-reduce:transition-none motion-reduce:hover:transform-none`}
            >
              <div id={prevElId} className={`flex justify-center items-center gap-0  mr-xs`}>
                <button className="w-[28px] h-[28px] box-material-primary shadow-elevation rounded-full stroke-white overflow-hidden">
                  <span className="flex items-center justify-center">
                    <Icon name="arrow-left" title="prev" size="20" />
                  </span>
                  <span className="sr-only">Prev slide</span>
                </button>
              </div>
              <div id={nextElId} className={`flex justify-center items-center gap-0`}>
                <button className="w-[28px] h-[28px] box-material-primary shadow-elevation rounded-full stroke-white overflow-hidden">
                  <span className="flex items-center justify-center">
                    <Icon name="arrow-right" title="next" size="20" />
                  </span>
                  <span className="sr-only">Next slide</span>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="grid grid-cols-3 gap-xxs md:hidden">
        <div className="col-span-2">
          <Image className="aspect-4-3 rounded-tl rounded-bl" alt={images![0].title || ""} src={images![0].url} width={550} height={205} />
        </div>
        <div className="col-span-1 grid grid-rows-2 gap-xxs">
          {images
            ?.slice(1, 3)
            .map((image, index) => (
              <Image
                key={image.url}
                className={`aspect-4-3 ${index === 0 ? "rounded-tr" : "rounded-br"}`}
                alt={image.title || ""}
                src={image.url}
                width={255}
                height={205}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
